<div class="block--content block" id="main-content">
    <ng-container *ngIf="this.flowStep === 1">
        <ridango-page-content-wrapper>
            <rwidget-alert></rwidget-alert>
            <ridango-ui-back-button (onBack)="onBack()"
                >{{ 'RELATED_CARD_DETAIL_BACK_LINK' | translate }}
            </ridango-ui-back-button>
        </ridango-page-content-wrapper>

        <div class="ticket">
            <ridango-page-content-wrapper>
                <div class="intro-text">
                    <h1 class="title">{{ 'REGISTER_SEUTULIPPU' | translate }}</h1>
                    <p>{{ 'REGISTER_SEUTULIPPU_DESCRIPTION' | translate }}</p>
                </div>
            </ridango-page-content-wrapper>

            <rwidget-register-seutulippu (onSaveSuccess)="handleSaveSuccess()"></rwidget-register-seutulippu>
        </div>
    </ng-container>

    <ng-container *ngIf="this.flowStep > 1">
        <ridango-page-content-wrapper>
            <rwidget-email-sent
                [title]="'SEUTULIPPU_REQUEST_SENT'"
                [description]="'SEUTULIPPU_REQUEST_SENT_DESCRIPTION'">
                <a
                    [routerLink]="'/account/seutulippu' | localize"
                    class="flex-center width-220 btn btn--primary btn--big link--no-line margin-bottom-20"
                    tabindex="0">
                    {{ 'BACK_TO_OVERVIEW' | translate }}
                </a>
            </rwidget-email-sent>
        </ridango-page-content-wrapper>
    </ng-container>
</div>
